<template>
  <v-tabs class="mt-0" v-model="currentProductTab">
    <v-tab> PRODUCTS</v-tab>
    <v-tab v-show="admin.selectedProduct != null">{{ productTabName }}</v-tab>
    <v-tab-item class="pa-2">
      <product-list></product-list>
    </v-tab-item>
    <v-tab-item class="pa-2">
      <v-row>
        <v-col>
          <product-edit></product-edit>
        </v-col>
        <v-col>
          <product-details
            v-show="
              admin.selectedProduct != null && admin.selectedProduct.id != 'new'
            "
          ></product-details>
        </v-col>
      </v-row>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import { mapState } from 'vuex';
  import ProductList from '../components/product/ProductList.vue';
  import ProductEdit from '../components/product/ProductEdit.vue';
  import ProductDetails from '../components/product/ProductDetails.vue';

  export default {
    components: { ProductList, ProductEdit, ProductDetails },
    data() {
      return {};
    },
    computed: {
      ...mapState(['app', 'admin']),
      currentProductTab: {
        get() {
          return this.admin.currentProductTab;
        },
        set(value) {
          this.$store.commit('admin/setCurrentProductTab', value);
        }
      },
      productTabName: {
        get() {
          let tabName = 'Edit Product';
          if (
            this.admin.selectedProduct &&
            this.admin.selectedProduct.id != 'new'
          ) {
            tabName = `Product [${this.admin.selectedProduct.name?.substring(
              0,
              20
            )}${this.admin.selectedProduct.name?.length > 20 ? '...' : ''}]`;
          } else if (
            this.admin.selectedProduct &&
            this.admin.selectedProduct.id == 'new'
          ) {
            tabName = 'Add New Product';
          }
          return tabName;
        }
      }
    },
    methods: {}
  };
</script>
